export const EVENTS_TRACKING = {
    INVITE_SENT: 'invite_sent_web',
}